var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6981 0.0820312H2.23899C1.53053 0.0820312 0.95816 0.654403 0.95816 1.36286V30.822C0.95816 31.5304 1.53053 32.1028 2.23899 32.1028H31.6981C32.4066 32.1028 32.9789 31.5304 32.9789 30.822V1.36286C32.9789 0.654403 32.4066 0.0820312 31.6981 0.0820312ZM10.4563 27.3677H5.70524V12.0858H10.4563V27.3677ZM8.08278 9.99646C7.53814 9.99646 7.00572 9.83496 6.55286 9.53237C6.1 9.22978 5.74704 8.79969 5.53862 8.29651C5.33019 7.79332 5.27565 7.23962 5.38191 6.70544C5.48817 6.17126 5.75044 5.68058 6.13556 5.29546C6.52069 4.91033 7.01136 4.64806 7.54555 4.5418C8.07973 4.43555 8.63342 4.49008 9.13661 4.69851C9.6398 4.90694 10.0699 5.2599 10.3725 5.71276C10.6751 6.16561 10.8366 6.69803 10.8366 7.24268C10.8326 8.76366 9.59977 9.99646 8.08278 9.99646ZM28.2439 27.3677H23.4968V19.9349C23.4968 18.1618 23.4648 15.8843 21.0272 15.8843C18.5576 15.8843 18.1773 17.8135 18.1773 19.8068V27.3677H13.4343V12.0858H17.9892V14.1752H18.0533C18.6857 12.9744 20.2347 11.7056 22.5482 11.7056C27.3593 11.7056 28.2439 14.8716 28.2439 18.9863V27.3677Z",
    fill: "#2091F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb4);
export default __webpack_public_path__ + "static/media/fb4.882a0fd354de07824c26a9d784ff1675.svg";
export { ForwardRef as ReactComponent };